import CodeMirror from 'codemirror';
import { ICustomProperty } from '../index.d';
import { createSpanReplacementNode } from '../markers/utils';
import { getCloseBracketPosition, splitTokensWithComma } from '../utils/codemirror';
import { getPrevEffectiveToken, hasTokenIncludes } from '../utils/codemirror';


function isBooleanToken(token: CodeMirror.Token) {
    return hasTokenIncludes(token, ['atom', 'Boolean']);
}

function isEnumToken(token: CodeMirror.Token) {
    return hasTokenIncludes(token, ['string']);
}

export function replaceEnumOptionText(
    editor: CodeMirror.Editor,
    tokens: CodeMirror.Token[],
    idx: number,
    customProperties: ICustomProperty[]
) {
    const token = tokens[idx];
    if (!token) { return 0; }


    const aduit: any = { mode: '', count: 0, endPosCh: 0, tokens: [] };

    const isBoolean = isBooleanToken(token);
    const isEnum = isEnumToken(token);
    const isCompleteId = isBoolean || isEnum;
    if (isCompleteId) {
        aduit.mode = 'Single';
        aduit.count = 1;
        aduit.endPosCh = token.end;
        aduit.tokens = [token];
    } else if (token.type === 'bracket' && token.string === '[') {
        const closeBracketIndex = getCloseBracketPosition(tokens, idx, '[', ']');

        if (closeBracketIndex > -1) {
            const tokensArr = splitTokensWithComma(tokens.slice(idx + 1, closeBracketIndex));
            if (tokensArr.every(innerTokens => isBooleanToken(innerTokens[0]) || isEnumToken(innerTokens[0]))) {
                aduit.mode = 'Array';
                aduit.count = closeBracketIndex - idx + 1;
                aduit.endPosCh = tokens[closeBracketIndex].end;
                aduit.tokens = tokensArr;
            }
        }
    }

    if (!aduit.mode) { return 0; }


    const operatorToken = getPrevEffectiveToken(editor, token)!;

    if (!hasTokenIncludes(operatorToken, ['operator'])) {
        return 0;
    }

    if (!hasTokenIncludes(operatorToken, ['IN'])
        && !hasTokenIncludes(operatorToken, ['NOT-IN'])
        && operatorToken.string !== '=='
        && operatorToken.string !== '!='
    ) {
        return 0;
    }

    const customPropertyToken = getPrevEffectiveToken(editor, operatorToken!);

    if (!hasTokenIncludes(customPropertyToken, ['custom-property-id'])) {
        return 0;
    }

    const customPropertyId = Number(customPropertyToken!.string.slice(1, -1));
    const customProperty = customProperties.find(item => item.id === customPropertyId);
    if (!customProperty || !['Enum', 'Boolean'].includes(customProperty.dataType)) { return 0; }

    const doc = editor.getDoc();
    const line = token.state.line;
    const startPos = { line, ch: token.start };
    const endPos = { line, ch: aduit.endPosCh };

    if (aduit.mode === 'Single') {
        const value = isBoolean ? (token.string === 'true' ? true : false) : JSON.parse(token.string);
        const option = customProperty.options!.find(item => item.value === value);
        if (option) {
            const node = createSpanReplacementNode(option.name, 'cm-enum-option-value');
            doc.markText(startPos, endPos, {
                replacedWith: node
            });
            return aduit.count;
        }
    } else {
        const values = aduit.tokens.map((tokenArr: CodeMirror.Token[]) => {
            const innerToken = tokenArr[0];
            const value = isBooleanToken(innerToken) ? (innerToken.string === 'true' ? true : false) : JSON.parse(innerToken.string);
            const option = customProperty.options!.find(item => item.value === value)!;
            return option ? option.name : 'Unknown';
        }).join(',');
        const node = createSpanReplacementNode(`[${values}]`, 'cm-enum-option-value');
        doc.markText(startPos, endPos, {
            replacedWith: node
        });
        return aduit.count;
    }

    return 0;
}
